import { MenuItem, styled } from '@mui/material';

export const RoleSelectorItem = styled(MenuItem)`
  text-transform: capitalize;
`;
